import { useEffect, useCallback } from 'react';
import { useAnalyticsEvents, fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';

const LegacyIssueCreateTrackers = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const trackLegacyIssueCreate = useCallback(
		(event: Event) => {
			if (!(event instanceof CustomEvent)) {
				return;
			}
			const payload = event.detail;
			const trackEvent = createAnalyticsEvent({});
			fireTrackAnalytics(trackEvent, 'issueCreated inProductSurvey', payload.objectId, {
				...payload.attributes,
			});
		},
		[createAnalyticsEvent],
	);

	useEffect(() => {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		document.addEventListener('legacy_legacyIssueCreated', trackLegacyIssueCreate);

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		return () => document.removeEventListener('legacy_legacyIssueCreated', trackLegacyIssueCreate);
	}, [createAnalyticsEvent, trackLegacyIssueCreate]);

	return null;
};

export default LegacyIssueCreateTrackers;
